'use strict';

var classCallCheck = require('../../node_modules/@babel/runtime/helpers/classCallCheck.js');
var createClass = require('../../node_modules/@babel/runtime/helpers/createClass.js');
var possibleConstructorReturn = require('../../node_modules/@babel/runtime/helpers/possibleConstructorReturn.js');
var getPrototypeOf = require('../../node_modules/@babel/runtime/helpers/getPrototypeOf.js');
var inherits = require('../../node_modules/@babel/runtime/helpers/inherits.js');
var React = require('react');
require('prop-types');
var AvatarButton = require('./AvatarButton.js');
var AccountSettingPopover = require('./AccountSettingPopover.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var AvatarButtonWithSettingsPopover =
/*#__PURE__*/
function (_PureComponent) {
  inherits(AvatarButtonWithSettingsPopover, _PureComponent);

  function AvatarButtonWithSettingsPopover(props) {
    var _this;

    classCallCheck(this, AvatarButtonWithSettingsPopover);

    _this = possibleConstructorReturn(this, getPrototypeOf(AvatarButtonWithSettingsPopover).call(this, props));
    _this.state = {
      openSettingsPopover: false,
      anchorEl: null
    };
    return _this;
  }

  createClass(AvatarButtonWithSettingsPopover, [{
    key: "closeSettingsPopover",
    value: function closeSettingsPopover() {
      this.setState({
        openSettingsPopover: false,
        anchorEl: null
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          avatarUrl = _this$props.avatarUrl,
          firstName = _this$props.firstName,
          lastName = _this$props.lastName,
          email = _this$props.email,
          showSettingsMenu = _this$props.showSettingsMenu,
          showAccountSettings = _this$props.showAccountSettings,
          showCompanySettings = _this$props.showCompanySettings,
          showLogOut = _this$props.showLogOut,
          _onAccountSettingsClicked = _this$props.onAccountSettingsClicked,
          _onCompanySettingsClicked = _this$props.onCompanySettingsClicked,
          onLogOut = _this$props.onLogOut;
      var _this$state = this.state,
          openSettingsPopover = _this$state.openSettingsPopover,
          anchorEl = _this$state.anchorEl;
      return React__default["default"].createElement(React.Fragment, null, React__default["default"].createElement(AvatarButton, {
        avatarUrl: avatarUrl,
        firstName: firstName,
        lastName: lastName,
        onButtonClick: function onButtonClick(target) {
          _this2.setState({
            openSettingsPopover: !openSettingsPopover,
            anchorEl: target
          });
        }
      }), showSettingsMenu && React__default["default"].createElement(AccountSettingPopover, {
        open: openSettingsPopover,
        anchorEl: anchorEl,
        avatarUrl: avatarUrl,
        firstName: firstName,
        lastName: lastName,
        email: email,
        showAccountSettings: showAccountSettings,
        showCompanySettings: showCompanySettings,
        showLogOut: showLogOut,
        onAccountSettingsClicked: function onAccountSettingsClicked() {
          _this2.closeSettingsPopover();

          _onAccountSettingsClicked();
        },
        onCompanySettingsClicked: function onCompanySettingsClicked() {
          _this2.closeSettingsPopover();

          _onCompanySettingsClicked();
        },
        onLogOut: onLogOut,
        onClose: function onClose() {
          return _this2.closeSettingsPopover();
        }
      }));
    }
  }]);

  return AvatarButtonWithSettingsPopover;
}(React.PureComponent);
AvatarButtonWithSettingsPopover.defaultProps = {
  avatarUrl: '',
  firstName: '',
  lastName: '',
  email: '',
  showSettingsMenu: true,
  showAccountSettings: true,
  showCompanySettings: true,
  showLogOut: true,
  onAccountSettingsClicked: function onAccountSettingsClicked() {},
  onCompanySettingsClicked: function onCompanySettingsClicked() {},
  onLogOut: function onLogOut() {},
  onClose: function onClose() {}
};

module.exports = AvatarButtonWithSettingsPopover;
